<script lang="ts">
  import { Icon, Link, ShoppingCartSolid } from "@getprovi/craft";
  import type {
    BuyingOption,
    FulfillmentSummary,
  } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";
  import { singular } from "@shared/svelte/Modules/pluralize";

  export let inventoryId: number;
  export let buyingOptions: BuyingOption[];
  export let fulfillmentSummary: FulfillmentSummary;

  const purchaseSummary = (buyingOptions: BuyingOption[]): string => {
    const quantitySummaries = [
      optionSummary(buyingOptions.find(option => option.quantity_type === "case")),
      optionSummary(buyingOptions.find(option => option.quantity_type === "unit")),
    ]
      .filter(summary => summary)
      .join(", ");

    return `${quantitySummaries} in cart for ${fulfillmentMethodSummary(fulfillmentSummary)}.`;
  };

  const fulfillmentMethodSummary = (fulfillmentSummary: FulfillmentSummary): string => {
    const { type, name } = fulfillmentSummary;
    return `${type}` + (name ? ` at ${name}` : "");
  };

  const optionSummary = (buyingOption: BuyingOption | undefined): string | undefined => {
    if (!buyingOption || buyingOption.quantity === 0) return;

    if (buyingOption.quantity === 1) {
      return `1 ${singular(buyingOption.label.toLowerCase())}`;
    }
    return `${buyingOption.quantity} ${buyingOption.label.toLowerCase()}`;
  };
</script>

<style>
  .truncate-purchase-summary {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
  }
</style>

<div
  class="fizz-flex-row fizz-justify-start fizz-align-items-center fizz-bordered fizz-inset-square-8 fizz-flex-row-4"
  data-testid={`alt-fulfillment-${inventoryId}`}
>
  <Icon iconName={ShoppingCartSolid} color="disabled" />
  <div>
    <p class="truncate-purchase-summary">
      {purchaseSummary(buyingOptions)}
    </p>
    <Link href="/cart" size="sm" class="font-normal">Modify in cart</Link>
  </div>
</div>
